import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper'
import { useStyles } from "../hooks/useStyles";
import { useFormats } from "../hooks/useSkuUtils";
import { useOrderItemChangeHandlers } from "../hooks/useUtils";
import { InputDynamicText } from '../components/InputDynamicText';
import { showRoundedAbsAmt, findAbsAmtAsPct,
          } from '../utils';
import { OutlayAmt } from '../components/OutlayAmt';
import AdminChangeOtherOrder from './AdminChangeOtherOrder'

export const OthersOrdersTable = ({
    if_shopper_is_circle_admin,
    trip,
    sku,
    actualWeight,
    othData,
    skuPrice,
   }) => {
  // console.log("ooB sku", sku)
  // console.log("ooC skuPrice", skuPrice)
  // FIX ME: need to use signedIn or shopper here?
  const { showOutlayWithTax,
            } = useContext(ShopperContext);

  const { textAlignRight,
            } = useStyles();
  const { spaceUnits,
            } = useFormats();
  const { handleMinMaxNoteClick } = useOrderItemChangeHandlers();

  const othersRows =
    othData.map((othd) => {
      // 'othd' is an object holding another CircleShopper's:
      // othShopperOrderItem: othShopperOrderItem,
      // othAbsAmt: othAbsAmt,
      // unitQty: unitQty,
      // adjustedAbsAmtAsPct: adjustedAbsAmtAsPct,

      // returns Who, Unit Qty, Wantd, Range Note, Outlay
    return (
    <tr key={'oo' + othd.othShopperOrderItem.id}>

      <td className='fw-bold'>
        {/* Who */}
        { othd.othShopperOrderItem.shopper.shortname }
      </td>

  {
    (if_shopper_is_circle_admin)
      ? <AdminChangeOtherOrder
          order={othd.othShopperOrderItem}
          skuPrice={skuPrice}
          actualWeight={actualWeight}
          trip={trip}
          sku={sku}
          isForOoTable={true}
        />
      :
        <>
      { sku.type === 'SingularItem'
        ? null
        : <td>
            {/* "UnitQty" - add sku.units (e.g. 'lb') if sku isWeighty */}
            {othd.unitQty}
            {sku.type === "WeightyItem"  &&  spaceUnits({units: sku.units})}
          </td>
      }
    
          <td style={textAlignRight}>
            {/* "%Wantd" */}
            {showRoundedAbsAmt({ 
                              adjustedAbsAmtAsPct: othd.adjustedAbsAmtAsPct
                                  }) + "%"}
          </td>
    
          <td>
            {/*  #-#  */}
            <InputDynamicText
              initialText = {othd.othShopperOrderItem.min_max_note || ''}
              handleTextClick =
                            {handleMinMaxNoteClick(othd.othShopperOrderItem.id)}
              placeholder = ''
              rows = {5}
              cols = {26}
              checkboxPosition = "side"
            />
          </td>
    
          <td>
           <div className = "oneline-container-right">
            <OutlayAmt
              trip        = {trip}
              sku         = {sku}
              sku_price   = {skuPrice}
              order       = {othd.othShopperOrderItem}
              decimal_amt = {
                        findAbsAmtAsPct({topNum: othd.othAbsAmt, sku}) /100
                            }
              showOutlayWithTax = {showOutlayWithTax}
            />
           </div>
          </td>
        </>
  }

    </tr>
        )
      })

  console.log("ooT othersRows", othersRows);
  return  othersRows.length > 0  ?  othersRows  :  null;
      };

export default OthersOrdersTable;